import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const HashingTechniques = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Hashing Techniques: Static and Dynamic Hashing"
    videos={[
      "https://www.youtube.com/embed/zeMa9sg-VJM",
      "https://www.youtube.com/embed/d_4SL3BRPuQ",
      "https://www.youtube.com/embed/oyF_aXJg6SM"
    ]}
    takeaways={[]}
    questions={[
      "Insert the elements 15,20,25 and 30 into a hash table of size 10. Assume that the h1(k) = 2K+3. The hash value is calculated from the formula h1(k) % table size. The Tables do not need to be resized. If an element cannot be inserted successfully, state why. You need to display it up to the final table.\ni) Perform quadratic probing\nii) Perform Double Hashing by using the secondary hash function h2(k)=3K+1",
      "Suppose that extendable hashing is being used on a database file that contains records with the following search key values: 8, 16, 4, 3, 14, 11, 12, 23, 42, 21. Construct the extendable hash structure for this file using the lowest-bits for the hash function (after converting the numbers into its binary form). That is, records in a bucket of local depth'd' agree on their rightmost 'n' bits. For example, the key 3 (0011) and 11 (1011) agree on their rightmost 3 bits (011). Each bucket can hold two records. Answer the followings based on the constructed extendable hash structure.\ni) What is the global depth of the resulting directory?\nii) What is the local depth of the bucket contains key 14?"
    ]}
    exampleVideos={[]}
  />
);
}

export default HashingTechniques;
